// extracted by mini-css-extract-plugin
module.exports = {"btn":"carouselArrows_btn__5gqN5","next":"carouselArrows_next__d5Bj1","prev":"carouselArrows_prev__LrJLV"};